import React, { FunctionComponent, MouseEvent } from 'react';
import { Button } from '@material-ui/core';
import simpleButtonStyles from './SimpleButtonStyles';
import clsx from 'clsx';
import { ButtonTypes } from '../../../enum/ButtonTypes';

export interface ISimpleButtonProps {
  type: 'simple' | 'filled';
  action: (event?: MouseEvent<HTMLButtonElement>) => void;
  dataTest: string;
  disabled?: boolean;
  color?: 'secondary' | 'primary';
  buttonClassName?: string;
}

const SimpleButton: FunctionComponent<ISimpleButtonProps> = ({
  type,
  action,
  dataTest,
  disabled = false,
  children,
  color,
  buttonClassName,
}) => {
  const buttonStyles = simpleButtonStyles();

  return (
    <Button
      variant={type === ButtonTypes.SIMPLE ? 'outlined' : 'contained'}
      color={color}
      disabled={disabled}
      onClick={action}
      onMouseDown={e => e.preventDefault()}
      data-test={dataTest}
      className={clsx([buttonStyles.button, { [buttonStyles.outlined]: type === ButtonTypes.SIMPLE }, buttonClassName])}
      classes={{
        label: buttonStyles.label,
      }}
    >
      {children}
    </Button>
  );
};

export default SimpleButton;
